// extracted by mini-css-extract-plugin
export default {"imgContain":"GM","content":"HM","titleAndImage":"IM","title":"JM","text":"KM","rhodeTitle":"LM","shortHR":"MM","modal_root":"NM","x_mark":"OM","flavorStickModal":"PM","greenBox":"QM"};
    if(module.hot) {
      // 1737143662454
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  